import { Router, } from '@angular/router';
import { RedirectToPhp } from '@freelancer/redirect-to-php';
import { switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./login.config";
import * as i2 from "@angular/router";
import * as i3 from "../redirect-to-php/redirect-to-php.service";
var LoginGuard = /** @class */ (function () {
    function LoginGuard(loginService, auth, router, redirectToPhp) {
        this.loginService = loginService;
        this.auth = auth;
        this.router = router;
        this.redirectToPhp = redirectToPhp;
    }
    LoginGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        return this.auth.isLoggedIn().pipe(switchMap(function (loggedIn) {
            var next = route.queryParams.next;
            // FIXME: temporary hack to unbreak T133950.
            var goto = route.queryParams.goto;
            if (goto) {
                return _this.redirectToPhp.doRedirect(state.url);
            }
            if (loggedIn) {
                return _this.router.navigate([next || '/']);
            }
            return _this.loginService.redirect(next, route);
        }));
    };
    LoginGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginGuard_Factory() { return new LoginGuard(i0.ɵɵinject(i1.LOGIN_REDIRECT_SERVICE), i0.ɵɵinject(i1.LOGIN_AUTH_SERVICE), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.RedirectToPhp)); }, token: LoginGuard, providedIn: "root" });
    return LoginGuard;
}());
export { LoginGuard };
